import { tsValidateString } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
const Validator_MandatoryPropsLaunchUrls = {
    label: tsValidateString(),
    organizationId: tsValidateString(),
    environmentId: tsValidateString(),
    quaiEnv: tsValidateString(),
    description: tsValidateString(),
    facilityId: tsValidateString(),
};
const Validator_GeneratedProps = {
    shortUrlId: tsValidateString()
};
export const DBDef_LaunchUrls = {
    modifiablePropsValidator: Validator_MandatoryPropsLaunchUrls,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'launch-urls',
    generatedProps: ['shortUrlId'],
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'launch-urls'
    },
    backend: {
        name: 'launch-urls'
    },
    entityName: 'LaunchUrls',
    dependencies: {
        organizationId: {
            dbKey: 'organizations',
            fieldType: 'string',
        },
        shortUrlId: {
            dbKey: 'short-url',
            fieldType: 'string',
        },
        environmentId: {
            dbKey: 'environments',
            fieldType: 'string',
        },
        facilityId: {
            dbKey: 'facility',
            fieldType: 'string',
        }
    }
};
//# sourceMappingURL=db-def.js.map